import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Success page specifically for iframe redirects from payment gateway
 * This page posts a message to the parent window and should not be navigated to directly
 * Renders an empty/invisible page to avoid flashing content in the iframe
 */
const PaymentIframeSuccess = () => {
    const location = useLocation();

    useEffect(() => {
        // Get payment token from URL if available
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        // Extract any transaction details from the URL
        const transactionId = params.get('transaction_id') || params.get('order_id') || 'unknown';

        // Post message to parent window immediately
        window.parent.postMessage({
            status: 'successful',
            transaction_id: transactionId,
            token: token
        }, '*');

        console.log('Posted success message to parent window');

        // After a brief delay, send another message as a safeguard
        setTimeout(() => {
            window.parent.postMessage({
                status: 'successful',
                transaction_id: transactionId,
                token: token,
                retry: true
            }, '*');
            console.log('Posted backup success message to parent window');
        }, 300); // Reduced delay to make transition faster

    }, [location]);

    // Return an empty/invisible page
    return null;
};

export default PaymentIframeSuccess; 